import React from 'react';
import { TutorialCard as TutorialCardType } from '../../types/dashboard';
import { IconPlayerPlayFilled } from '@tabler/icons-react';
import styles from './DashboardCards.module.scss';

interface TutorialCardProps {
  data: TutorialCardType;
}

const TutorialCard: React.FC<TutorialCardProps> = ({ data }) => {
  return (
    <div className={`${styles.summaryCard} ${styles.lastCard}`}>
      <div className={styles.cardContent}>
        <div className={styles.contentWrapper}>
          <div className={styles.cardTitle}>
          <IconPlayerPlayFilled />
            <span>{data.title}</span>
          </div>
          <p className={styles.cardDescription}>
            {data.description}
          </p>
        </div>
        <button 
          className={styles.getStartedButton}
          onClick={data.onButtonClick}
        >
          <span>{data.buttonText}</span>
        </button>
      </div>
    </div>
  );
};

export default TutorialCard; 